<template>
  <div class="a">
    <Nav/>
    <PageBannerBig :banner="banner"></PageBannerBig>
    <Service/>
    <Contact/>
    <Footer/>
  </div>
</template>

<script>
import Nav from '@/components/Nav'
import PageBannerBig from '@/components/PageBannerBig'
import Service from '@/components/Service'
import Contact from '@/components/Contact'
import Footer from '@/components/Footer'
export default {
  name: '',
  components: {
    Nav,
    PageBannerBig,
    Service,
    Contact,
    Footer
  },
  data () {
    return {
      banner: {
        img: require("@/assets/img/service-banner.png"),
        title: "技术改变未来",
        sub: "创新型技术服务商"
      }
    }
  }
}
</script>

<style scoped lang="less">
.a{
  .b{
    font-size: 30px;
  }
}
</style>
